import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { roofingServicePages } from "@/data/roofingServiceContent";

const c = roofingServicePages["flat-roof-repair"];

export const Route = createFileRoute("/services/flat-roof-repair")({
  head: () => ({
    meta: [
      { title: "Flat Roof Repair Southern California | McKay Roofing & Solar" },
      { name: "description", content: "Flat and low-slope roof repair in Southern California for seams, flashing and drainage problems on residential and commercial buildings." },
      { property: "og:title", content: "Flat Roof Repair – McKay Roofing & Solar" },
      { property: "og:description", content: c.heroSubtitle },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/flat-roof-repair" }],
  }),
  component: () => <RoofingServicePage {...c} />,
});